import {SleepAsync} from "js-vextensions";

export async function GetPromiseAndResolveRejectFuncs<T>() {
	let resultPromise_resolve: ((value: T | PromiseLike<T>) => void) | n;
	let resultPromise_reject: ((reason?: any) => void) | n;
	const resultPromise = new Promise<T>((resolve, reject)=>{
		resultPromise_resolve = resolve;
		resultPromise_reject = reject;
	});
	while (resultPromise_resolve == null || resultPromise_reject == null) {
		await SleepAsync(0);
	}
	return {
		promise: resultPromise,
		resolve: resultPromise_resolve,
		reject: resultPromise_reject,
	};
}

export class CancelableContext {
	constructor() {
		this.controller = new AbortController();
	}

	controller: AbortController;
	Cancel() {
		this.controller.abort();
	}

	sequenceCompleted = false;
	MarkSequenceCompleted() {
		this.sequenceCompleted = true;
	}
	CancelAfterXIfSequenceNotCompleted(checkDelayInMS: number) {
		if (this.sequenceCompleted) return this;
		setTimeout(()=>{
			if (!this.sequenceCompleted) {
				this.Cancel();
			}
		}, checkDelayInMS);
		return this;
	}

	async Await<T>(promise: Promise<T>): Promise<T> {
		this.controller.signal.throwIfAborted();
		let promiseRaceCompleted = false;
		const result = await Promise.race([
			promise.then(value=>{
				promiseRaceCompleted = true;
				return value;
			}).catch(error=>{
				promiseRaceCompleted = true;
				throw error;
			}),
			new Promise<T>((_, reject)=>{
				this.controller.signal.addEventListener("abort", ()=>{
					// only call reject if the promise-race hasn't completed yet (this way, we avoid a [not useful] "unhandled promise rejection" pause in dev-tools)
					if (!promiseRaceCompleted) {
						promiseRaceCompleted = true;
						reject(new AbortError("Aborted"));
					}
				});
			})
		]);
		return result;
	}
}
export class AbortError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "AbortError";
	}
}